import React from 'react';
import { Chip } from '@mui/material';
import { statusColors } from '../../theme/tokens';

const formatStatusLabel = (status) =>
  String(status || 'not_initiated')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Soft, tinted status chip. Single source of truth for status -> color/label
 * mapping (theme/tokens.js#statusColors) so every page's badges agree.
 */
const StatusBadge = ({ status, label, size = 'small', sx }) => {
  const key = String(status || 'default').trim().toLowerCase();
  const palette = statusColors[key] || statusColors.default;

  return (
    <Chip
      label={label || formatStatusLabel(status)}
      size={size}
      sx={{
        backgroundColor: palette.bg,
        color: palette.color,
        border: `1px solid ${palette.border}`,
        fontWeight: 600,
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
